import React from 'react';
import ServicesHero from './Services/ServicesHero';
import OurServicesCardForServicePage from './Services/OurServicesCardForServicePage';
import PhotoGalleryList from './Services/PhotoGalleryList';
import ServicesSEO from "./../seo/ServicesSEO";
import { Helmet } from "react-helmet-async";
import '../css/Services.css';


export default function Services() {

  return (
    <main>

      <Helmet>
              <title>Madeshwara Ambulance Services | 24/7 Ambulance Services in Bangalore and Karnataka</title>
      </Helmet>

      <ServicesSEO />
      
      <section> 
        <ServicesHero />
      </section>

      <section> 
        <OurServicesCardForServicePage/>
      </section>

      <section className="pt-8 pb-16 mx-6 sm:mx-6 ">
        <PhotoGalleryList />
      </section>

    </main>
  );
}
